import React, { Component } from "react";
import PageEditor from "../PageEditor/PageEditor";
import "./HandPrint.css";
import mixins from "../../app-services/mixins";
import { readUrl } from "../PageEditor/support";
import { staticPages, pageStyle, getPages } from "./handprintConfig";
import PreInfoColletion from "./Preinfo";
import { withRouter } from "react-router";
import { Button } from "@mui/material";
import uploadplaceholder from "./uploadPlaceholder.png";
import { replaceHandprintBgImages } from "./images";
export class HandPrint extends Component {
  constructor(props) {
    super(props);
    this.BOOKID = props.match.params.id;
    initialConstruct.bind(this)("HandPrint");
    const book = props.store.book.customCharacter;
    this.pageeditorref = React.createRef();
    this.state = {
      pageStyle,
      staticPages,
      savedBook: {},
      bolierplates: {},
      svgs: {},
      pages: getPages(book),
      overlayStyle: {},
    };
  }

  getContent(book, page) {
    let ele = mixins.getDataNode(replaceHandprintBgImages(book));
    const handprintPreInfo = this.props.store?.book?.handprintPreInfo;
    const answer = handprintPreInfo?.answer;
    const handprints = handprintPreInfo?.handprints;
    if (page.assetname && handprints?.[page.assetname]) {
      let imgEle = ele.querySelector("#image-element");
      imgEle.src = handprints[page.assetname].filepath;
    }
    let child_name = ele.querySelector("#child_name");
    if (child_name && answer && answer.child_name) {
      child_name.innerText = answer.child_name;
    }
    let dedictaion_text = ele.querySelector("#dedictaion_text");
    if (dedictaion_text && answer && answer.dedication) {
      dedictaion_text.innerText = answer.dedication;
    }
    let adult_name = ele.querySelector("#adult_name");
    if (adult_name && answer && answer.parent_name) {
      adult_name.innerText = answer.parent_name;
    }
    book = ele.innerHTML;
    return book;
  }
  getLatestBook() {
    let self = this;
    const handprintPreInfo = this.props.store?.book?.handprintPreInfo;
    return new Promise((resolve, reject) => {
      api
        .getUpdatedSelfBook({
          sessionId: localStorage.getItem("sessionID") || null,
          type: "handprint",
        })
        .then((responce) => {
          if (responce && responce.data) {
            let payload = responce.data;
            let remoteHadprintAttributes = JSON.parse(
              payload.attributes || "{}"
            );
            this.setStore("book.handprintPreInfo", {
              ...handprintPreInfo,
              ...remoteHadprintAttributes,
            });
            this.setState({
              savedBook: payload,
            });
            setTimeout(() => {
              resolve(payload);
            });
          } else {
            resolve(this.state.savedBook);
          }
        })
        .catch(reject);
    });
  }

  async updateBook(payload) {
    let self = this;
    const { savedBook } = self.state;
    const BOOKID = self.BOOKID;
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    await api.updateSelfPublish(
      {
        bookId: BOOKID,
        savedBook: JSON.stringify(payload),
        option: "dynamic",
        sessionId: localStorage.getItem("sessionID") || null,
        type: "handprint",
        attributes: JSON.stringify(handprintPreInfo),
      },
      savedBook.id
    );
  }

  onSave(payload, self) {
    const BOOKID = self.BOOKID;
    const { savedBook } = self.state;
    let history = self.history;
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    return new Promise((resolve, reject) => {
      mixins.checkLogin(self.history).then(() => {
        if (savedBook && savedBook.id) {
          self.updateBook(payload).then((responce) => {
            self
              .getLatestBook()
              .then((responce) => {
                resolve(responce);
              })
              .catch(reject);
          });
        } else {
          api
            .createSelfPublish({
              bookId: BOOKID,
              savedBook: JSON.stringify(payload),
              option: "dynamic",
              sessionId: localStorage.getItem("sessionID") || null,
              file: null,
              type: "handprint",
              attributes: JSON.stringify(handprintPreInfo),
            })
            .then((responce) => {
              self.history.push(
                self.history.location.pathname + `/${responce.data.id}`
              );
              setTimeout(() => {
                self
                  .getLatestBook("createmsg")
                  .then((responce) => {
                    resolve(responce);
                  })
                  .catch(reject);
              });
            });
        }
      });
    });
  }
  onUpdate() {}
  updateBoilerplate() {
    return new Promise((resolve, reject) => {
      let { staticPages } = this.state;
      let promises = Object.entries(staticPages).map(([key, url]) => {
        return new Promise((resolve, reject) => {
          readUrl(url)
            .then((responce) => resolve({ key, responce: replaceHandprintBgImages(responce) }))
            .catch(reject);
        });
      });
      Promise.all(promises)
        .then((responce) => {
          let bolierplates = responce.reduce(
            (o, n) => ({ ...o, [n.key]: n.responce }),
            {}
          );
          resolve(bolierplates);
        })
        .catch(reject);
    });
  }
  onProceed(...arg) {
    this.uploadHanprints(...arg).then(() => {
      this.pageeditorref.current.querySelector("#previewBook").click();
    });
  }
  updateChanges(payload, modal) {
    let self = this;
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    let preInfo = handprintPreInfo || {};
    preInfo.answer = payload;
    preInfo.answer = payload;
    self.setStore("book.handprintPreInfo", preInfo);
    modal && modal.close();
    setTimeout(() => {
      self.updateData();
    }, 0);
  }
  uploadHanprints(payload, modal) {
    //console.log({uploadHanprints:payload});
    return new Promise((resolve, reject) => {
      let self = this;
      const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
      let preInfo = handprintPreInfo || {};
      if (
        payload.child_handprint instanceof File ||
        payload.parent_handprint instanceof File
      ) {
        const formData = new FormData();
        formData.append("child", payload.child_handprint);
        formData.append("adult", payload.parent_handprint);
        api
          .uploadHandprint(formData)
          .then((responce) => {
            if (responce && responce.statusCode === 200) {
              preInfo.handprints = Object.map(responce.data, (o) => ({
                ...o,
                filepath: "data:image/png;base64," + o.image_base64,
              }));
              preInfo.folder = responce.folder;
              preInfo.answer = payload;
              self.setStore("book.handprintPreInfo", preInfo);
              modal && modal.close();
              self.updateData().then(resolve).catch(reject);
            } else {
              alert(responce.msg);
              reject(responce.msg);
            }
          })
          .catch(reject);
      } else {
        //console.log({preInfo});
        preInfo.answer = payload;
        self.setStore("book.handprintPreInfo", preInfo);
        modal && modal.close();
        setTimeout(() => {
          self.updateData().then(resolve).catch(reject);
        }, 0);
      }
    });
  }
  collectInfo(closable = false) {
    let onChange = (answer) => {};
    let modal = alert(
      (props) => (
        <PreInfoColletion
          closable={closable}
          alert={props}
          id={this.BOOKID}
          onChange={(...arg) => onChange(...arg)}
          onSave={(...arg) => this.onProceed(...arg)}
          onClose={(...arg) => this.onProceed(...arg)}
        />
      ),
      "",
      "model",
      {
        footer: false,
        class: "",
        parentclass: "HandPrint",
        options: {},
      }
    );
  }
  updateData() {
    return new Promise((resolve, reject) => {
      let { savedBook } = this.state;
      this.updateBoilerplate()
        .then((bolierplates) => {
          let book = savedBook?.savedBook?.parse({}) || {};
          let pages = this.state.pages.map((o) => ({
            ...o,
            content: this.getContent(
              book[o.name] || o.content || bolierplates[o.name] || "",
              o
            ),
          }));
          this.setState({
            bolierplates: bolierplates,
            pages,
          });
          resolve(pages);
        })
        .catch(reject);
    });
  }
  prepareForCollection() {
    let {
      match: {
        params: { genpdf, customBookId },
      },
    } = this.props;
    const handprintPreInfo = this.props.store?.book?.handprintPreInfo;
    const handprints = handprintPreInfo?.handprints;
    if (
      !handprintPreInfo ||
      !handprints ||
      (handprints && Object.keys(handprints).length <= 0 && !customBookId)
    ) {
      this.collectInfo();
    } else {
      this.updateData().then(() => {
        this.pageeditorref.current.querySelector("#previewBook").click();
      });
    }
  }
  componentDidMount() {
    emit.on("updatebook", async (...arg) => await this.updateBook(...arg));
    this.getLatestBook()
      .then(() => {
        this.prepareForCollection();
      })
      .catch(() => {
        this.prepareForCollection();
      });
  }
  componentWillUnmount() {
    emit.remove("updatebook");
  }
  RightChildren(self) {
    return () => (
      <Button
        className="edit"
        variant="outlined"
        id="editBook"
        onClick={() => self.collectInfo(true)}
      >
        <i className="fa fa-edit"></i>
        <small>Edit</small>
      </Button>
    );
  }
  getNoticeMeesage() {
    let defaultmessage = "";
    let device = this.$store.device;
    if (["mob", "small", "tab", "lap"].includes(device)) {
      defaultmessage +=
        "<br/><span style='font-size:12px; color:#cc3300; font-weight:400;'>Books Best view in Desktop version only</span>";
    }
    return defaultmessage;
  }

  onPreviewClose(alert) {
    alert.close();
    //history.back();
  }

  render() {
    let me = this;
    let noticeMessage = this.getNoticeMeesage();
    return ((
      { savedBook, pages, overlayStyle, pageStyle },
      props,
      { onSave, RightChildren }
    ) => (
      <div className="HandPrint top-margin" ref={me.pageeditorref}>
        <PageEditor
          pagePayload={pages}
          onSave={(...arg) => onSave(...arg, this)}
          charcount={100}
          lastPageNo={31}
          overlay={true}
          style={overlayStyle}
          leftTool={false}
          readonly={true}
          editbackground={false}
          RightChildren={RightChildren(this)}
          showCount={false}
          pageBordered={false}
          pageStyle={pageStyle}
          uploadplaceholder={uploadplaceholder}
          nextmode={true}
          bookDetails={savedBook}
          message={noticeMessage}
          closablePreview={false}
          onPreviewClose={(...arg) => this.onPreviewClose(...arg)}
        ></PageEditor>
      </div>
    ))(this.state, this.props, this);
  }
}
export default connect(withRouter(HandPrint));
